module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAxMyAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAgMEgxM0w4LjQ1IDguNTk4ODRIMTNMMy45IDI0LjU2ODFWMTQuNzQwOUgwVjBaTTIuNiAyLjQ1NjgxVjEyLjI4NDFINi41VjE1LjU1MTZMOS4xIDExLjA1NTdINC4yMTJMOC43ODggMi40NTY4MUgyLjZaIiBmaWxsPSIjRjZCNzE1Ii8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./static/website/images/energy.svg
// module id = L12d
// module chunks = 1